
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import DocShell from "@/src/layouts/DocShell";
import DocNavItem from "@/src/components/docs/DocNavItem";
import Page from "@/src/components/Page";
import H1 from "@/src/components/docs/H1";
import H2 from "@/src/components/docs/H2";
import CustomLink from "@/src/components/CustomLink";
import { IoRemoveOutline } from "react-icons/io5";
import { MdCheckCircle } from "react-icons/md";
import {
  Box,
  List,
  ListIcon,
  ListItem,
  Text,
  useColorMode,
} from "@chakra-ui/react";

// Les libellés portent leurs liens sous la forme [[texte|url]] : le contenu
// reste ainsi entièrement traduisible sans balisage dans les fichiers de
// traduction.
const LINK = /\[\[([^|\]]+)\|([^\]]+)\]\]/g;

const withLinks = (text) => {
  const parts = [];
  let last = 0;
  let match;

  LINK.lastIndex = 0;
  while ((match = LINK.exec(text)) !== null) {
    if (match.index > last) parts.push(text.slice(last, match.index));
    parts.push(
      <CustomLink key={`${match.index}-${match[2]}`} to={match[2]}>
        <Text as={"a"} color={"brand.500"}>
          {match[1]}
        </Text>
      </CustomLink>
    );
    last = match.index + match[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));

  return parts.length ? parts : text;
};

const TermsConditions = () => {
  const { t } = useTranslation("terms");
  const { colorMode } = useColorMode();
  const isLight = colorMode === "light";

  const bodyColor = isLight ? "inherit" : "white";
  const headingColor = isLight ? "inherit" : "brand.600";

  const sections = t("sections", null, { returnObjects: true }) || [];

  const renderBlock = (block, i) => {
    if (block.type === "list") {
      return (
        <List key={i} spacing={3} mt={4} ml={{ base: 3, lg: 6 }}>
          {block.items.map((item, j) => (
            <ListItem key={j} color={bodyColor} lineHeight={"1.6"} textAlign={"justify"}>
              <ListIcon as={MdCheckCircle} color={"brand.500"} />
              {withLinks(item)}
            </ListItem>
          ))}
        </List>
      );
    }

    if (block.type === "h") {
      return (
        <H2 key={i} color={bodyColor} py={4}>
          {withLinks(block.text)}
        </H2>
      );
    }

    return (
      <Text
        key={i}
        as={"p"}
        py={2}
        lineHeight={"1.6"}
        textAlign={"justify"}
        color={bodyColor}
        fontWeight={block.bold ? "semibold" : "normal"}
      >
        {withLinks(block.text)}
      </Text>
    );
  };

  return (
    <DocShell
      aside={
        <>
          {sections.map((section) => (
            <DocNavItem
              key={section.id}
              icon={IoRemoveOutline}
              to={section.id}
            >
              {section.title}
            </DocNavItem>
          ))}
        </>
      }
    >
      <Box as={"article"} py={4} px={{ base: 2, md: 8, xl: 12 }}>
        <H1 color={headingColor}>{t("title")}</H1>
        <Text as={"h3"} py={4} color={bodyColor}>
          {t("updated")}
        </Text>
      </Box>

      {sections.map((section) => (
        <Box
          key={section.id}
          as={"article"}
          py={4}
          px={{ base: 2, md: 8, xl: 12 }}
        >
          <H1 id={section.id} color={headingColor} py={4}>
            {section.title}
          </H1>
          <Box
            ml={{ base: "9px", lg: "18px" }}
            py={5}
            color={isLight ? "gray.700" : "white"}
          >
            {section.blocks.map(renderBlock)}
          </Box>
        </Box>
      ))}
    </DocShell>
  );
};

const TermsConditionsPage = () => (
  <Page name="Terms & conditions" path="/docs/terms-conditions">
    <TermsConditions />
  </Page>
);

export default TermsConditionsPage;


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/docs/terms-conditions',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  